import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {convertCurrencyFormat} from "../../util/numberConvertor";
import moment from "jalali-moment";
import {useDebounce} from "@uidotdev/usehooks";
import {TransactionService} from "../../serverService/transactionService/TransactionService";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoCustomTable, RaikoGridOneColumn,
    RaikoNumberInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    RaikoDateInputOutlined,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../context/AuthContext";

export const TransactionsList = ({gateWayId = -1}) => {

    let page = 0
    const size = 20
    const {fundID} = useAuthState()


    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const service = new TransactionService()

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [transactionList, setTransactionList] = useState([]);

    const [fullName, setFullName] = useState("");
    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [groupName, setGroupName] = useState("");
    const [groupCode, setGroupCode] = useState("");
    const [summationOfAmount, setSummationOfAmount] = useState("")

    const _startDateFilter = useDebounce(startDateFilter, 300)
    const _endDateFilter = useDebounce(endDateFilter, 300)
    const _fullNameFilter = useDebounce(fullName, 300)
    const _groupNameFilter = useDebounce(groupName, 300)
    const _groupCodeFilter = useDebounce(groupCode, 300)


    const [statusFilter, setStatusFilter] = useState(paymentStatus.ALL.id);

    const [numberOfItems, setNumberOfItems] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }

    }, [
        _fullNameFilter,
        _groupNameFilter,
        _groupCodeFilter,
        _startDateFilter,
        _endDateFilter,
        fundID
    ]);

    function getDataFromServer(status = statusFilter) {
        setIsLoading(true)

        service.getTransactionListData(
            fundID,
            fullName,
            groupName,
            groupCode,
            startDateFilter,
            endDateFilter,
            status,
            page,
            size,
        ).then(response => {

            setPageCount(response.totalPage)

            setTransactionList([])
            setNumberOfItems(response.numberOfItems)

            response.data.map((item, index) => {
                setTransactionList(prevState => [
                    ...prevState,
                    prepareTransactionListRow(
                        item.id,
                        (page * size) + index + 1,
                        item.payerFirstName && item.payerLastName ? `${item.payerFirstName} ${item.payerLastName}` : "-",
                        item.payerNationalCode,
                        item.createdAtDate,
                        item.status,
                        item.amount,
                        item.createdAtPersianTime,
                        item.paymentGatewayTitle,
                    )
                ])
            })
            setSummationOfAmount(response.summationOfAmount)

            setIsLoading(false)
        }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست تراکنشات."))
            setIsLoading(false)
        })
    }

    function prepareTransactionListRow(
        id,
        number,
        payerFullName,
        payerNationalCode,
        createdAtDate,
        status,
        amount,
        hour,
        paymentGatewayTitle,
    ) {

        const m = moment(hour, "hh:mm:ss")
        m.local('fa')


        return {
            id: id,
            number,
            payerFullName: payerFullName ? payerFullName : "-",
            amount: convertCurrencyFormat(amount),
            payerNationalCode: payerNationalCode ? payerNationalCode : "-",
            createdAtDate: convertUniversalDateToPersianDate(createdAtDate),
            createdTime: `${m.format('HH:mm:ss')}`,
            paymentGatewayTitle: paymentGatewayTitle ? paymentGatewayTitle : "-",
            status: status === paymentStatus.SUCCESS.id ?
                <RaikoCustomSimpleChip
                    title={paymentStatus.SUCCESS.name}
                    type={RaikoChipTypes.success}/> :
                status === paymentStatus.UN_SUCCESS.id ?
                    <RaikoCustomSimpleChip
                        title={paymentStatus.UN_SUCCESS.name}
                        type={RaikoChipTypes.error}/> :
                    <RaikoCustomSimpleChip
                        title={paymentStatus.AWAITING_FOR_PAYMENT.name}
                        type={RaikoChipTypes.warning}/>

        }
    }


    function checkFilters() {
        let state = false
        let message = ""

        if (startDateFilter.length > 0 && startDateFilter.length !== 10)
            message = "لطفا تاریخ شروع بازه را به درستی وارد نمایید!"
        else if (endDateFilter.length > 0 && endDateFilter.length !== 10)
            message = "لطفا تاریخ پایان بازه را به درستی وارد نمایید!"
        else
            state = true

        snackbar.showWarningMessage(message)

        return state
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    const navigate = useNavigate()

    function showTransactionDetail(id) {
        navigate(RouteHelper.TransactionDetail.globalUrl.replace(":id", id))
    }

    function handleDeleteAllFilters() {
        setGroupName("");
        setGroupCode("")
        setStartDateFilter("");
        setEndDateFilter("");
        setStatusFilter(paymentStatus.ALL.id);
    }

    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    {
                        gateWayId === -1 &&
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator("تراکنشات", ""),
                            raikoBreadCrumbItemGenerator("سابقه تراکنشات", ""),
                        ]}/>
                    }

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"تراکنش ها"}
                                amount={numberOfItems}
                            />
                            <RaikoTableSearchContainer
                                hasFilter={true}
                                labelText={"نام"}
                                placeHolder={"عبارت مورد نظر را وارد نمایید"}
                                setValue={setFullName}
                                value={fullName}
                                handleDeleteAllFilters={handleDeleteAllFilters}
                                filterStatus={
                                    parseInt(startDateFilter) > 0 ||
                                    parseInt(endDateFilter) > 0 ||
                                    statusFilter !== paymentStatus.ALL.id
                                }
                            >
                                <RaikoGridOneColumn>
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام گروه"}
                                        setValue={setGroupName}
                                        value={groupName}/>
                                    <RaikoNumberInputOutlined
                                        labelText={"کد گروه"}
                                        value={groupCode}
                                        setValue={setGroupCode}
                                    />
                                    <RaikoDateInputOutlined
                                        labelText={"شروع بازه"}
                                        setValue={setStartDateFilter}
                                        value={startDateFilter}/>
                                    <RaikoDateInputOutlined
                                        labelText={"پایان بازه"}
                                        setValue={setEndDateFilter}
                                        value={endDateFilter}/>
                                    <RaikoCustomSelect
                                        labelText={"وضعیت"}
                                        setValue={setStatusFilter}
                                        onChange={e => {
                                            getDataFromServer(e.target.value)
                                        }}
                                        items={[
                                            raikoCustomSelectItemGenerator(paymentStatus.ALL.id, paymentStatus.ALL.name),
                                            raikoCustomSelectItemGenerator(paymentStatus.SUCCESS.id, paymentStatus.SUCCESS.name),
                                            raikoCustomSelectItemGenerator(paymentStatus.UN_SUCCESS.id, paymentStatus.UN_SUCCESS.name),
                                            raikoCustomSelectItemGenerator(paymentStatus.AWAITING_FOR_PAYMENT.id, paymentStatus.AWAITING_FOR_PAYMENT.name),
                                        ]}
                                        value={statusFilter}
                                    />
                                </RaikoGridOneColumn>
                            </RaikoTableSearchContainer>
                            <RaikoCustomTable
                                isLoading={isLoading}
                                data={transactionList}
                                header={transactionHeader}
                                handlePaginationChange={handleChangePagination}
                                pageCount={pageCount}
                                rowClicked={showTransactionDetail}
                                summationOfAmount={summationOfAmount}
                                currencyUnit={"ریال"}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


export const paymentStatus = {
    ALL: {
        id: "ALL",
        name: "همه"
    }, SUCCESS: {
        id: "SUCCESS",
        name: "موفق"
    }, UN_SUCCESS: {
        id: "UN_SUCCESS",
        name: "ناموفق"
    }, AWAITING_FOR_PAYMENT: {
        id: "AWAITING_FOR_PAYMENT",
        name: "در حال انجام"
    },
}

const transactionHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "payerFullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "payerNationalCode",
        label: "کدملی"
    }, {
        id: "amount",
        label: "مبلغ (ریال)"
    }, {
        id: "createdAtDate",
        label: "تاریخ"
    }, {
        id: "createdTime",
        label: "زمان"
    }, {
        id: "paymentGatewayTitle",
        label: "درگاه پرداخت"
    },  {
        id: "status",
        label: "وضعیت"
    },
]